/**
 * Les couleurs du bouton qui agrandit l'activité au live (`<ActivityWidthToggle>`) : pures (aucun
 * Unistyles), pour que `theme/contrast.test.ts` le mesure dans les deux thèmes de l'élève. Une surface qui
 * flotte, à cheval sur la visio et l'activité : son chevron à l'encre du texte ; en clair, son ombre la
 * détache ; sur la nuit, où l'ombre ne se voit pas, son contour.
 */
import type { SemanticColorKey } from "../../theme/tokens/colors"

export const ACTIVITY_WIDTH_TOGGLE_FACE = {
    fill: "surface-floating",
    ink: "text-primary",
    edge: "border",
} as const satisfies Record<string, SemanticColorKey>
